import React from 'react';
import { StyleSheet } from 'react-native';
import {
  Button,
  Card,
  LabelText,
  theme,
  TitleText,
  useResponsive,
} from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuRecommendation = (props: MenuRecommendationProps) => {
  const { match } = useResponsive();

  const cardStyle = [styles.card, match([styles.cardXS, styles.cardSM])];
  const labelTextStyles = [styles.label, Palette[props.theme].text];
  const titleStyles = [styles.title, Palette[props.theme].text];
  const ctaStyles = match([styles.buttonXS, styles.buttonSM]);

  return (
    <Card style={cardStyle} backgroundColor={Palette[props.theme].cardColor}>
      <LabelText style={labelTextStyles} size={match([3, 1])}>
        {props.label}
      </LabelText>

      <TitleText style={titleStyles} sizeMatch={['24', '32', '40']}>
        {props.title}
      </TitleText>

      <Button
        size={match(['medium', 'large'])}
        style={ctaStyles}
        palette={Palette[props.theme].buttonPalette}
        onPress={props.onPress}
      >
        {props.action}
      </Button>
    </Card>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  card: {
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: theme.spacing['6'],
    borderRadius: theme.radius.large,
  },
  cardXS: {
    paddingHorizontal: theme.spacing['4'],
    paddingVertical: theme.spacing['6'],
  },
  cardSM: {
    minHeight: 278,
  },
  label: {
    marginBottom: theme.spacing['1'],
  },
  title: {
    textAlign: 'center',
  },
  buttonXS: {
    marginTop: theme.spacing['2'],
    width: '100%',
  },
  buttonSM: {
    marginTop: theme.spacing['2'],
    paddingHorizontal: theme.spacing['10'],
  },
  textForSpinach: {
    color: theme.colors.GREEN_2,
  },
  textForSquash: {
    color: theme.colors.LIME,
  },
});

const Palette = {
  spinach: {
    text: styles.textForSpinach,
    cardColor: theme.colors.KHAKI_2,
    buttonPalette: 'secondary' as const,
  },
  squash: {
    text: styles.textForSquash,
    cardColor: theme.colors.GREEN_2,
    buttonPalette: 'limeOutlineFull' as const,
  },
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuRecommendationProps = Readonly<{
  theme: 'spinach' | 'squash';
  label: string;
  title: string;
  action: string;
  onPress: () => void;
}>;
